import AccessProtectedRoute from "../components/AccessProtectedRoute";
import { subRouteLink } from "./routeLinks";
import { Navigate, Route } from "react-router-dom";
import React from "react";
import {
  NavigateToCurrentOnboardingStep,
  OnboardingStepGuard,
} from "./onboardingRouteHelpers";

const generateRoutes = (routes) => {
  return routes.map((route) => {
    if (route.routes) {
      const isGrouped = route.areSubRoutesGroupedSidebarTabs;
      // Shared route wrapper
      return (
        <Route path={route.path} key={route.path}>
          <Route
            index
            element={
              <AccessProtectedRoute
                feature={route.feature}
                featureProtected={route.featureProtected}
                allowedUserStatuses={route.allowedUserStatuses}
              >
                {isGrouped ? (
                  <NavigateToCurrentOnboardingStep
                    onboardingRoutes={route.routes}
                  />
                ) : (
                  <Navigate
                    to={subRouteLink(route.path, route.routes[0].path)}
                    replace
                  />
                )}
              </AccessProtectedRoute>
            }
          />
          {route.routes.map((subRoute) => (
            <Route
              key={subRoute.path}
              path={subRoute.path}
              element={
                <AccessProtectedRoute
                  feature={route.feature}
                  subFeature={subRoute.subFeature}
                  featureProtected={subRoute.subFeatureProtected}
                  allowedUserStatuses={subRoute.allowedUserStatuses}
                >
                  {isGrouped ? (
                    <OnboardingStepGuard
                      stepNumber={subRoute.stepNumber}
                      element={subRoute.element}
                    />
                  ) : (
                    subRoute.element
                  )}
                </AccessProtectedRoute>
              }
            />
          ))}
        </Route>
      );
    }

    // Nav-link-only entries (e.g. the header dropdown's "Brand Profile" shortcut,
    // whose `path` points at a route another entry already registers) carry neither
    // `.routes` nor `.element` — they exist only to be read as metadata by their
    // section's consumer (getHeaderProfileDropdownRoutes, the sidebar), not to
    // register a page of their own. Skipping them here is what makes it safe for
    // their `.path` to equal — or point into — another entry's real route.
    if (!route.element) return null;

    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          <AccessProtectedRoute
            feature={route.feature}
            featureProtected={route.featureProtected}
            allowedUserStatuses={route.allowedUserStatuses}
          >
            {route.element}
          </AccessProtectedRoute>
        }
      />
    );
  });
};

export default generateRoutes;
